import {IconWrapper} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "aria-hidden": "true",
  "data-slot": "icon",
  viewBox: "0 0 512 512"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createStaticVNode("<mask id=\"i734170713__a\"><circle cx=\"256\" cy=\"256\" r=\"256\" fill=\"#fff\"></circle></mask><g mask=\"url(#i734170713__a)\"><path fill=\"#0052b4\" d=\"M0 0h133.6l35.3 16.7L200.3 0H512v222.6l-22.6 31.7 22.6 35.1V512H200.3l-32-19.8-34.7 19.8H0V289.4l22.1-33.3L0 222.6z\"></path><path fill=\"#ffda44\" d=\"M133.6 0v222.6H0v66.8h133.6V512h66.7V289.4H512v-66.8H200.3V0z\"></path></g>", 2)
  ])))
}
export default { render() { return h(IconWrapper, {icon: {render}, name: "swedish"}) } }